import axios from 'axios';

const API_URL = process.env.VUE_APP_SERVICES_HOST;
const PREFIX_REPORT = 'reports/';

class ReportService{
    get_entity(entity) {        
        return axios.get(API_URL + PREFIX_REPORT +  entity);
    }

    create_entity(payload, entity){
        return axios.post(API_URL + PREFIX_REPORT + entity, payload);
    }

    update_entity(payload, entity){
        return axios.put(API_URL + PREFIX_REPORT + entity, payload);
    }

    delete_entity(payload, entity){
        return axios.delete(API_URL + PREFIX_REPORT + entity,  { data: payload } );
    }

    upload_images(payload, entity){
        const config = { headers: { "Content-Type": "multipart/form-data" } };        
        return axios.post(API_URL + PREFIX_REPORT + entity, payload, config);
    }
}

export default new ReportService();
